import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { RippleService } from '../../../@core/utils/ripple.service';
import { environment } from '../../../../environments/environment';
import { UsersService } from '../../../_services/users.service';
import { RoleProvider } from '../../../_helpers/role.provider';
import { CompaniesService } from '../../../_services/companies.service';
import { User } from '../../../_models/user.type.model';
import { NbAuthService } from '@nebular/auth';
import { Router } from '@angular/router';

@Component({
    selector: 'ngx-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  public readonly materialTheme$: Observable<boolean>;
  userPictureOnly: boolean = false;
  user: User | undefined;

  themes = [
    // {
    //   value: 'corporate',
    //   name: 'Corporate',
    // },
    // {
    //   value: 'dark',
    //   name: 'Dark',
    // },
    {
      value: 'material-light',
      name: 'Material Light',
    },
    {
      value: 'material-dark',
      name: 'Material Dark',
    },
  ];

  currentTheme = 'material-light';
  appName = '';

  userMenu = [
    // TODO: fare mini pagina anagrafica account loggato
    // { title: 'Profilo', link: 'pages/anagrafica' },
    { title: 'Modifica Password', link: 'pages/user/change-password', icon: "shield-outline"},
    { title: 'Esci', link: '/auth/logout', icon: "log-out-outline"}
  ];

  public constructor(
    private sidebarService: NbSidebarService,
    private authService: NbAuthService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private rippleService: RippleService,
    private usersService: UsersService,
    private router: Router,
    private companiesService: CompaniesService,
    private roleProvider: RoleProvider,
  ) {
    this.materialTheme$ = this.themeService.onThemeChange()
      .pipe(map(theme => {
        const themeName: string = theme?.name || '';
        return themeName.startsWith('material');
      }));
  }

  preProcessUserData(data: any): User {

    let user: User = {
      name: data.registry.name + " " + data.registry.surname,
      picture: data.company.logo ? data.company.logo : 'assets/images/user_account_icon.jpg',
      title: data.company.name,
    }
    return user;
  }

  async ngOnInit() {

    this.currentTheme = this.themeService.currentTheme;
    this.user = { name: 'Ospite', picture: '../../../../assets/images/user_account_icon.jpg', title: "", };

     // USER PROFILE
     let token = await this.authService.getToken().toPromise();
     try{
      let userId = token?.getPayload()?.["hasura_claims"]?.['x-hasura-user-id'];
      this.usersService.getUserById(userId).toPromise().then((data) => {
        this.user!.name = data.name + " " + data.surname;
      })
      .catch(err => {
        console.log('.......',err);
      });
     }
     catch(err){
      this.router.navigateByUrl("/auth/login");
     }

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => {
        this.currentTheme = themeName;
        this.rippleService.toggle(themeName?.startsWith('material'));
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  toggleTheme() {
    // const newTheme = this.currentTheme === "material-light" ? "material-dark" : "material-light";
    // this.themeService.changeTheme(newTheme);
  }
}
